import { CryptoKey } from "../utils/emunData";
import Crypto from "../utils/crypto";
import {
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpUploadFormData,
} from "../utils/http";

export default class {
  apiEndpoint = null;

  constructor(apiEndpoint) {
    this.apiEndpoint = apiEndpoint;
  }

  // updateReceive(
  //   _id,
  //   receive,
  //   receiveMethod,
  //   transferAccount,
  //   issuer,
  //   creditCardNumber,
  //   note,
  //   optUserID
  // ) {
  //   let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
  //     "CLINIC"
  //   )}/billing/receiveLog?docID=${_id}&optUserID=${optUserID}`;

  //   return httpPost(apiUrl, {
  //     receive,
  //     receiveMethod,
  //     transferAccount,
  //     issuer,
  //     creditCardNumber,
  //     note,
  //   });
  // }

  updateReceives(
    bills,
    method,
    receive,
    depositUsed,
    receiveDate,
    transferAccount,
    issuer,
    creditCardNumber,
    note,
    optUserID,
    isBadDebt
  ) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/billing/receiveLogs?optUserID=${optUserID}`;

    return httpPost(apiUrl, {
      bills,
      method,
      receive,
      depositUsed,
      receiveDate,
      transferAccount,
      issuer,
      creditCardNumber,
      note,
      isBadDebt,
    });
  }

  getReceive(dateBegin, dateEnd) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/billing/receiveLog/list?dateBegin=${dateBegin}&dateEnd=${dateEnd}`;
    return httpGet(apiUrl);
  }

  getReceiveStat(conditions) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/billing/receiveLog/stat`;

    return httpPost(apiUrl, conditions);
  }

  getReceiveByConditions(conditions) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/billing/receiveLog/list`;

    return httpPost(apiUrl, conditions);
  }

  getReceiveLogByReceiveLogID(receiveLogID) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/billing/receiveLog/${receiveLogID}`;

    return httpGet(apiUrl);
  }

  editReceive(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/billing/receiveLog/edit`;

    return httpPost(apiUrl, data);
  }

  deleteReceive(data) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/billing/receiveLog/delete`;

    return httpPost(apiUrl, data);
  }

  exploreBilling(condition) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/billing/explore`;
    return httpPost(apiUrl, condition);
  }

  getBillingsByCondition(userID, petID, type, billStatus, currentPage) {
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${localStorage.getItem(
      "CLINIC"
    )}/billing/${Crypto.encrypt(
      userID,
      CryptoKey
    )}?type=${type}&billStatus=${billStatus}&currentPage=${currentPage}&petID=${petID}`;
    return httpGet(apiUrl);
  }

  getUndoneBillings(userID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/${clinicID}/billing/undone/user/${Crypto.encrypt(
      userID,
      CryptoKey
    )}`;
    return httpGet(apiUrl);
  }

  getUndoneBillingsByPetID(petID, clinic) {
    let clinicID = clinic ? clinic : localStorage.getItem("CLINIC");
    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/${clinicID}/billing/undone/pet/${Crypto.encrypt(
      petID,
      CryptoKey
    )}`;
    return httpGet(apiUrl);
  }

  saveBillBelongs(data) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/billing/distribution`;
    return httpPost(apiUrl, data);
  }

  getBillDistribution(recordID) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${
      this.apiEndpoint
    }/api/sdk/v2/${clinicID}/billing/distribution/${Crypto.encrypt(
      recordID,
      CryptoKey
    )}`;
    return httpGet(apiUrl);
  }

  getBillBelongs(data) {
    let clinicID = localStorage.getItem("CLINIC");
    let apiUrl = `${this.apiEndpoint}/api/sdk/v2/${clinicID}/billing/distribution/getList`;
    return httpPost(apiUrl, data);
  }
}
